import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetProductListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    selectedIsCustomActives: CustomMultiSelectModel[]
    selectedIsSubProducts: CustomMultiSelectModel[]
    selectedProductGroups: CustomMultiSelectModel[]
    selectedProducts: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetProductListPagingAndFilterRequest: GetProductListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    selectedIsCustomActives: [],
    selectedProductGroups: [],
    selectedProducts: [],
    selectedIsSubProducts: [],
    // Açılışta yalnız aktif ürünler (eski filtre panelinin varsayılanı "Aktif: Evet").
    columnFilters: [{ column: 'isCustomActive', values: ['1'], valueLabels: ['Evet'] }]
}